import React, { ReactNode } from "react";
/** re-use with a bit of additional CSS */
import "./IconButton.css";
import "./IconDropdown.css";

interface Props {
  onSelection: (index: number) => void;
  icons: Array<ReactNode>;
  titles: Array<string>;
  collapsedTitle: string;
  selectedIndex: number;
  disabled?: boolean;
  mini?: boolean;
}
interface State {
  isExpanded: boolean;
}

export default class IconDropdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }
  firstExpandedRef = React.createRef<HTMLButtonElement>();
  firstItemCollapseRef = React.createRef<HTMLButtonElement>();

  componentDidUpdate(_oldProps: Props, oldState: State) {
    // If using spacebar, nice to see first element highlighted before/after expand.
    // Conveniently (at least in chrome) there's no visual highlight unless the user has been keyboarding
    if (!oldState.isExpanded && this.state.isExpanded) {
      this.firstExpandedRef.current?.focus();
    } else if (oldState.isExpanded && !this.state.isExpanded) {
      this.firstItemCollapseRef.current?.focus();
    }
  }

  handleExpand = () => {
    this.setState({ isExpanded: true });
  };

  handleSelect = (index: number) => {
    this.props.onSelection(index);
    this.setState({ isExpanded: false });
  };

  curryHandleSelect = (index: number) => {
    return () => this.handleSelect(index);
  };

  render() {
    const { collapsedTitle, titles, icons, selectedIndex, disabled, mini } = this.props;
    const { isExpanded } = this.state;
    const stolenClassNames = `icon-button-wrapper ${mini ? "mini-button" : ""}`;
    const classNameCollapsed = `icon-dropdown-collapsed ${stolenClassNames}`;
    const classNameExpanded = `icon-dropdown-expanded ${stolenClassNames}`;

    return (
      <>
        {!isExpanded && (
          <span className={classNameCollapsed}>
            <button
              ref={this.firstItemCollapseRef}
              type="button"
              title={collapsedTitle}
              onClick={this.handleExpand}
              disabled={disabled}
              aria-disabled={disabled}
            >
              {icons[selectedIndex]}
            </button>
          </span>
        )}
        {isExpanded && (
          <span className={classNameExpanded}>
            <>
              {icons.map((ico, index) => {
                const ref = index === 0 ? this.firstExpandedRef : undefined;
                return (
                  <button
                    ref={ref}
                    key={"ico-dropdown" + index}
                    type="button"
                    title={titles[index]}
                    onClick={this.curryHandleSelect(index)}
                  >
                    {ico}
                  </button>
                );
              })}
            </>
          </span>
        )}
      </>
    );
  }
}

// <div className="icon-dropdown-list">
//   <div className="icon-dropdown-list-absolute">
//       {icons.map((ico, index) => {
//         return (
//           <div key={"ico" + ico} className="icon-dropdown-list-item">
//             <IconButton mini icon={ico} title={titles[index]} onClick={this.curryHandleSelect(index)} />;
//           </div>
//         );
//       })}
//     </div>
//   </div>
